import { z } from 'zod';
import { TypedApiClient } from '../index';
import { schemas } from '../../generated/api-client';
import { apiPath } from '../path';

// ====== Import schemas from generated ======
const {
  WriteOffReasonFirestoreResponse,
  CreateWriteOffReasonDto,
  UpdateWriteOffReasonDto,
  DeleteWriteOffReasonResponseDto,
} = schemas;

// ====== Re-export schemas for external use ======
export const WriteOffReasonResponseSchema = WriteOffReasonFirestoreResponse;
export const CreateWriteOffReasonSchema = CreateWriteOffReasonDto;
export const UpdateWriteOffReasonSchema = UpdateWriteOffReasonDto;

// ====== Type Exports ======
export type WriteOffReasonResponse = z.infer<typeof WriteOffReasonFirestoreResponse>;
export type CreateWriteOffReason = z.infer<typeof CreateWriteOffReasonDto>;
export type UpdateWriteOffReason = z.infer<typeof UpdateWriteOffReasonDto>;

// API factory function
export function createWriteOffReasonsApi(client: TypedApiClient) {
  return {
    getWriteOffReasons: (): Promise<WriteOffReasonResponse[]> => {
      return client.get('/write-off-reasons', {
        responseSchema: z.array(WriteOffReasonFirestoreResponse),
      });
    },

    createWriteOffReason: (data: CreateWriteOffReason): Promise<WriteOffReasonResponse> => {
      return client.post('/write-off-reasons', {
        data,
        requestSchema: CreateWriteOffReasonDto,
        responseSchema: WriteOffReasonFirestoreResponse,
      });
    },

    updateWriteOffReason: (id: string, data: UpdateWriteOffReason): Promise<WriteOffReasonResponse> => {
      return client.patch(apiPath`/write-off-reasons/${id}`, {
        data,
        requestSchema: UpdateWriteOffReasonDto,
        responseSchema: WriteOffReasonFirestoreResponse,
      });
    },

    deleteWriteOffReason: (id: string): Promise<z.infer<typeof DeleteWriteOffReasonResponseDto>> => {
      return client.delete(apiPath`/write-off-reasons/${id}`, {
        responseSchema: DeleteWriteOffReasonResponseDto,
      });
    },
  };
}
